import { Container } from "react-bootstrap";
import Navbar from "./Navbar";
import Footer from "./Footer";
function Introduction() {
  return (
    <div>
      <Navbar />
      <Container>
        <br />
        <h2 className="text-center mt-4 ">
          Quyida "Pay IT Forward" website🌐 haqida qisqacha ma'lumot beriladi.
        </h2>
        <hr />
        <h4>1. Loyihaning asosiy maqsadi🥅:</h4>
        <hr />
        <p>
          Bu loyiha veb dasturlashga qiziquvchi 7 yoshdan 👧🏻👦 70 yoshgacha 👩🏻🧔🏻
          bo'lgan yigit-qiz, erkak-ayollarni 👵🏼👴🏻 to'plab, ularga yo'l-yo'riq,
          ko'rsatmalar berib, dasturchilar safini kengaytirishga qaratilgandir.
        </p>
        <h4>2. Biz bilan dasturlashni o'rganish 📚 va "to'lov" tartibi 💸:</h4>
        <hr />
        <p>
          Dasturlashni o'rganish "Piramida sxemasi" asosida bo'ladi. Yo'q, bu
          siz bir paytlar katta pul tikib, keyin afsus qilib qolgan Piramida
          sxemasi emas😄. Bu saytda dasturchilar daraxti shakllangan bo'lib, u
          piramida ko'rinishida. <br />
          <ul>
            <li>
              Siz daraxtdan birorta dasturchi bilan bog'lanib uning jamoasiga
              qo'shilasiz.
            </li>
            <li>Jamoa bilan birga bir xil mavzularni o'zlashtirib borasiz.</li>
            <li>
              Qiziqarli vazifalar, har kunlik Stand-up lar va Haftalik
              Retrolarda ishtirok etasiz.
            </li>
          </ul>
          To'lov tartibi <i>mutlaqo tekin</i>, lekin bu biroz qimmatga tushishi
          mumkin🤑. Sababi darslar nihoyasiga yetgandan keyin, o'zingiz kamida 3
          (uch) dona shogird topib ularni o'zingiz qanday o'rgangan bo'lsangiz,
          shunday tartibda o'qitasiz va ularga ham shu "narx"ni aytasiz.
        </p>
        <h4>3. Nimalarni o'rgatamiz📝:</h4>
        <hr />
        <p>
          Asosan Veb-dasturlashning Front-end qismini, yani internet
          foydalanuvchilarga ko'rinadigan qismini tuzishni o'rganamiz.
        </p>
        <p>
          Bunda bizga <strong>HTML, CSS, JAVASCRIPT, BOOTSTRAP, REACT</strong>{" "}
          kabi bir qancha texnologiyalar kerak bo'ladi.
        </p>
        <h4>4. Darslar qachon yakunlanadi🔚:</h4>
        <hr />
        <p>
          Siz qo'shilgan jamoa a'zolari hamma har xil muddatda darslarni
          tugatishi mumkin. Biz ko'rsatgan yo‘l xaritasini tugatib (bunga
          taxminan 1 yil ketadi), biror maoshli ishga kirib olgandan keyingina
          darslarni yakunladingiz deyishimiz mumkin.
        </p>
        <h4>5. Hozirgi jamoa haqida👥:</h4>
        <hr />
        <h5>Bahriddin Abdiev jamoa sardori 💪🏼:</h5>
        <hr />
        <p>
          Avstralianing <a href="https://ferocia.com.au/">Ferocia</a>{" "}
          kompaniyasi senior dasturchisi. 7 yillik tajribaga ega. Hobbiylar:
          yugurish, stol tennisi, velosiped haydash, bog'dorchilik, Arduino
          bilan Hardware+Software loyihachalar qilish.
        </p>
        <h5> - Otabek Kadirov:</h5>
        <p>
          Ingliz tili o'qituvchisi, Front-end dasturchi. Hobbiylari: kino, stol
          tennisi, video o‘yinlar. Maqsadi: - kuchli dasturchi bo'lib, FAANG
          kompaniyalarida tajriba orttirish.
        </p>
        <h5> - Oybek Turaev:</h5>
        <p>
          Frontend dasturchi. Hozirgi ish faoliyati Assalam Group kompaniyasida
          frontendchi sifatida. Qiziqishlari: - til o'rganish. Maqsadi: - MERN
          stack dasturchisi bo'lish.
        </p>
        <h5> - Eldor Ergashov:</h5>
        <p>
          TATU talabasi, Frontend dasturchi, Informtech uz youtube kanali
          asoschisi, qiziqqan sport turi shaxmat. Maqsadi: Full Stack dasturchi bo'lish.
        </p>
        <h5> - Husan Eshonqulov:</h5>
        <p>
        Frontend dasturchi, TDTU talabasi. Foydalanadigan
        dasturlash tili - JavaScript. Qiziqishlari: xotira va aqliy o'yinlar.
        Maqsadi: kuchli va O'zbekistonga foydasi tegadigan dasturchi bo'lish.
        </p>
        <h4>6.
        Bo‘lajak shogirdlarga talablarimiz❗️:</h4>
        <hr />
        <p>
        <ol>
            <li>Sizda eng avvalo ichki
        qiziquvchanlik 🔥 va xohish kuchli bo'lishi kerak. Dasturchilikni tekin
        manbalardan o'rganish mumkin, lekin buni birovning undovi bilan o'rganib
        bo'lmaydi.</li>
            <li>Manbalarning ko'pchiligi ingliz tilida bo'lganligi sababli,
        sizda ingliz tili 🏴󠁧󠁢󠁥󠁮󠁧󠁿 eng kamida pre-intermediate darajasida bo'lishi
        kerak. Rus tili ham albatta asqotadi.</li>
            <li>Albatta hech bir ishga mas'uliyat
        🧐 bilan qaralmasa u ish chala bo'lishi yoki umuman bo'lmasligi ham
        mumkin. Shuning uchun sizdan mas'ulayat ham talab qilinadi.</li>
        <li>Sabr☝️😌.
        Dasturchilikni hamma ham tanlamasligining eng asosiy sababi mana shu
        talabda. Dasturchilik bu xuddi zargarlik ishiga o'xshaydi. Uning har bir
        mayda detallariga e'tibor qaratmasangiz bo'lmaydi. Hatto eng qo'pol va
        xunuk sayt tayyorlash uchun ham eng mayda piksel, millimetrlarni hisobga
        olish kerak bo'ladi.</li>
        </ol>
        </p>
        
               <h4>Barchaga omad!</h4>
               <br />
      </Container>
      <Footer />
    </div>
  );
}

export default Introduction;
